import React, {useCallback} from 'react'
import {flowRight} from 'lodash-es'
import qs from 'query-string'

// Components
import SaleComponent from '../sale/sale.component'

// Constants
import {SALE_BY_DISTRICT} from '~/constants/pages.constant'
import {APP_URL} from '~/constants/app.constant'

// HOCs
import {withHooks, withLayout} from '~/hocs'

// Utils
import {pathReplacer, renderHtml} from '~/utils'

import extraContent from './extraContent.json'

const useHooks = (props) => {
  const {
    navigate,
    pageContext: {
      products,
      limit,
      page,
      pageCount,
      totalCount: count,
      districtName,
      slug,
      id,
    },
  } = props

  const hidePrevButton = page > Math.ceil(pageCount)
  const hideNextButton = page >= Math.ceil(pageCount)

  const pathWithoutPage = pathReplacer(SALE_BY_DISTRICT, {slug})

  const handlePageChange = useCallback(
    ({selected}) => {
      const pageIndex = selected + 1

      navigate(pageIndex === 1 ? pathWithoutPage : `${pathWithoutPage}/trang-${pageIndex}`)
    },
    [navigate, pathWithoutPage],
  )

  const hrefBuilder = useCallback(
    (pageIndex) => (pageIndex === 1 ? pathWithoutPage : `${pathWithoutPage}/trang-${pageIndex}`),
    [pathWithoutPage],
  )

  const handleOrderTypeChange = ({
    target: {
      value,
    },
  }) => {
    const queryString = qs.stringify({
      orderType: value,
      isFor: 'sale',
      district: id,
    })

    navigate(`/search?${queryString}`)
  }

  const returnValue = {
    productsPerPage: limit,
    page,
    products,
    count,
    pageCount,
    hidePrevButton,
    hideNextButton,
    districtName,
    headTitle: 'Mua Bán Nhà Đất Quận 7 Vị Trí Đẹp, Giá Mới Nhất 2021',
    mainTitle: (
      <>
        {'Bán nhà '}
        <span className='green'>{districtName}</span>
      </>
    ),
    handlePageChange,
    hrefBuilder,
    handleOrderTypeChange,
  }

  if (slug === 'quan-7') {
    returnValue.keywords = 'Bán nhà quận 7, mua nhà quận 7'
    returnValue.description = 'Mua bán nhà đất Quận 7 chính chủ, vị trí đẹp, giao thông thuận tiện. Mua bán bất động sản giá rẻ, giá mới nhất 2021. Cập nhật chi tiết trong bài viết sau.'
    returnValue.extraContent = renderHtml(extraContent.content)

    if (page > 1) {
      returnValue.canonical = `${APP_URL}${pathWithoutPage}`
    }
  }

  return returnValue
}

const SalePage = flowRight(
  withHooks(useHooks),
  withLayout({pageName: SALE_BY_DISTRICT}),
)(SaleComponent)

export default SalePage
